import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';
import {
  ImportItems,
  MonitoringFiles,
  MonitoringTreatments,
} from '../models/monitoring.model';
import { GlobalService } from '@core/services/global.service';

@Injectable({
  providedIn: 'root',
})
export class MonitoringService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly globalService: GlobalService = inject(GlobalService);

  apiUrl = environment.api.root;
  user = this.globalService.getCurrentUserData();

  // Récupère la liste de tous les fichiers Excel importés avec pagination
  getPaginatedFiles(
    page: number = 1,
    pageSize: number = 200,
    language: string = 'fr'
  ): Observable<MonitoringFiles> {
    return this.http.get<MonitoringFiles>(`${this.apiUrl}/Global/files`, {
      params: {
        page: page.toString(),
        pageSize: pageSize.toString(),
        language: language,
      },
    });
  }

  // Récupère les résultats des traitements SMS après import avec pagination
  getPaginatedTreatment(
    id: string,
    page: number = 1,
    pageSize: number = 200,
    language: string = 'fr'
  ): Observable<MonitoringTreatments> {
    return this.http.get<MonitoringTreatments>(
      `${this.apiUrl}/global/treatment`,
      {
        params: {
          page: page.toString(),
          pageSize: pageSize.toString(),
          language: language,
          fileId: id,
        },
      }
    );
  }

  // Récupère le contenu de la table tbimport avec pagination
  getPaginatedImports(
    fichierId: number,
    page: number = 1,
    pageSize: number = 200,
    language: string = 'fr'
  ): Observable<ImportItems> {
    return this.http.get<ImportItems>(`${this.apiUrl}/global/imports`, {
      params: {
        fichierId: fichierId.toString(),
        page: page.toString(),
        pageSize: pageSize.toString(),
        language: language,
      },
    });
  }
}
